import { StoreId } from "../../decorators/StoreIdDecorator";
import { StoreName } from "../../decorators/StoreNameDecorator";
import { AbstractRemovableStore } from "../RemovableStore";

class WindowProxyStoreValue {
  @StoreId
  id: string;
  window: WindowProxy;

  constructor(id: string, windowProxy: WindowProxy) {
    this.id = id;
    this.window = windowProxy;
  }
}

@StoreName("WindowProxyStore")
class WindowProxyStoreClass<
  __ extends string,
  _ extends WindowProxyStoreValue,
> extends AbstractRemovableStore<string, WindowProxyStoreValue> {
  lookup(key: string): Promise<WindowProxyStoreValue | undefined> {
    throw new Error("Method not implemented.");
  }

  storedObjectKeysEquals(a: string, b: string): boolean {
    return a === b;
  }

  getAll(): Array<WindowProxyStoreValue> {
    return this.values;
  }

  closeAll(): void {
    this.values.splice(0, this.values.length).forEach((w) => w.window.close());
  }

  close(id: string) {
    const w = this.getWithoutLookup(id);
    if (w) {
      w.window.close();
    }
    this.remove(id);
  }
}

const WindowProxyStore = new WindowProxyStoreClass();
export { WindowProxyStore, WindowProxyStoreClass, WindowProxyStoreValue };
